import { cache } from './util';
export class UiConfigStaticRepository {
    constructor(defs) {
        this.defs = defs;
    }
    getUiConfig() {
        const domain = UiConfigStaticRepository.getDomain();
        const def = this.defs.find((def) => {
            return this.matchesDomain(def, domain);
        });
        if (def === undefined) {
            throw new Error(`No context definition found for domain ${domain}`);
        }
        return UiConfigStaticRepository.mapDefinitionToUiConfig(def);
    }
    matchesDomain(def, domain) {
        return def.matchers.find(matcher => {
            if (UiConfigStaticRepository.isExactHostMatcher(matcher)) {
                return matcher.exact === domain;
            }
            if (UiConfigStaticRepository.isRegexHostMatcher(matcher)) {
                return new RegExp(matcher.regex).test(domain);
            }
            throw new Error('Invalid matcher type');
        });
    }
    static getDomain() {
        return window.location.host;
    }
    static mapDefinitionToUiConfig(def) {
        return {
            contextId: def.contextId,
            contextCode: def.code,
            theme: def.theme,
            locales: def.locales,
            gaMeasurementId: def.gaMeasurementId
        };
    }
    static isExactHostMatcher(matcher) {
        return 'exact' in matcher;
    }
    static isRegexHostMatcher(matcher) {
        return 'regex' in matcher;
    }
}
